import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { initialChats, initialMessages } from '../data'; 
import api from '../utils/api';
import FullScreenLoader from '../components/Loader';

const ChatPage = () => {
  const [allMessages, setAllMessages] = useState(initialMessages);
  const [chatList, setChatList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    fetchChatList();
    
    const autoRefresh = setInterval(() => {
      fetchChatList();
    }, 5000);

    return () => clearInterval(autoRefresh);
  }, []);

  const fetchChatList = async() =>{
    try {
      const res = await api.get('/contacts');

      if(res?.status == 200){
        setChatList(res.data);
      }
    } catch (err) {
      console.log(err);
    } finally{
      setLoading(false);
    }
  }

  const handleSendMessage = (chatId, text) => {
    const newMessage = {
      id: Date.now(),
      text: text,
      sender: 'me',
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      isRead: false
    };

    setAllMessages((prev) => ({
      ...prev,
      [chatId]: [...(prev[chatId] || []), newMessage]
    }));
  };

  return (
    <div className="app-container">
      {loading && <FullScreenLoader />}
      <Sidebar chats={chatList} />
      <Outlet context={{ chats: initialChats, messagesData: allMessages, onSendMessage: handleSendMessage }} />
    </div>
  );
};

export default ChatPage;